import { Feature, MultiPolygon, Polygon } from '@turf/turf';
import * as turf from '@turf/turf';

export class PolygonMerger {
    merge = (polygons: Feature<Polygon>[]): Feature<Polygon>[] => {
        let mergedFeature!: Feature<Polygon | MultiPolygon>;

        for (const feature of polygons) {
            if (!mergedFeature) {
                // make a copy... in case there is only one, we don't want to return our input
                mergedFeature = JSON.parse(JSON.stringify(feature));
            } else {
                const result = turf.union(mergedFeature, feature);
                if (!result) {
                    throw new Error('got null when merging two polygons');
                }

                mergedFeature = result;
            }
        }
        if (mergedFeature.geometry.type === 'MultiPolygon') {
            return mergedFeature.geometry.coordinates.map(coords => turf.polygon(coords));
        }
        return [mergedFeature as Feature<Polygon>];
    }
}
